<template lang="pug">
#approval-body
  van-nav-bar(title='我的创建' left-text='返回' left-arrow @click-left='onClickLeft' v-if="!isProject" @click-right='onClickRight')
  van-dropdown-menu(active-color="#3873FE" style="height:35px;")
    van-dropdown-item(v-model='form.flowType' title='流程类型' :options='definitionList' @change='dressingByScreen')
    van-dropdown-item(v-model='form.flowInstanceOwnerId' title='申请人' :options='userList' @change='dressingByScreen')
    van-dropdown-item(ref='timeSearch' v-model='form.startDate' title='申请时间' @open='timeOpen')
      van-calendar(ref='calendar' title="申请时间选择" type="range" class="calendar" color="#1989fa" :row-height="48"
       :min-date="minDate" :max-date="maxDate" :poppable="false" @confirm="timeChange" :style="{ height: '60vh' }")
      van-button.timeBtn(round @click="clearStartTime") 清空
  van-search(v-model="form.keywords" shape="round" clearable background="#F5F6FA" placeholder="请输入关键词" @input="inputSearch" @clear="inputClear")
  .content
    approvalList(ref="approvalList" :finished="finished" @on-pulldown-loading="refrash" @on-pullup-loading="loadMore")
      approvalItem(ref="approvalItem" :list="feedbackList"  @onClick="lookClick")
</template>
<script>
import flowService from "@/CommonDP/service/flow-service";
import approvalList from "../components/approvalList.vue";
import approvalItem from "../components/approvalItem.vue";
import { mapState } from "vuex";
import { getStatusName } from "@/CommonDP/components/processComponents/config";
import { appBackMethods } from "@/CommonDP/pages/appView/utils";
import moment from "moment";

function Form() {
  return {
    keywords: "",
    flowInstanceOwnerId: "",
    approveTime: "",
    flowType: ""
  };
}
export default {
  components: {
    approvalList,
    approvalItem
  },
  props: {
    // 是否是项目内审批
    isProject: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: Form(),
      userList: [],
      definitionList: [],
      minDate: moment().subtract(1, "y").toDate(),
      maxDate: moment().add(1, "y").toDate(),
      queryParams: {
        page: 1,
        pageSize: 10
      },
      totalRecords: 0,
      feedbackList: [],
      selectData: [
        {
          text: "全部",
          value: ""
        }
      ]
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    // 触底
    finished() {
      let {pageSize, page} = this.queryParams ||{};
      return page * pageSize + 1 > this.totalRecords;
    }
  },
  mounted() {
    this.getUserList();
    this.getDefinitionList();
    this.reset();
  },
  methods: {
    // 查看详情
    async lookClick(row) {
      const { currentVersionId = "", flowInstanceId = "", flowKey, businessId = "", status } = row;
      let data = { currentVersionId, flowInstanceId, flowKey, approveType: "view", businessId, enterpriseId: this.enterpriseId };
      const statusName = getStatusName(status);
      if (statusName === "草稿") data = { ...data, approveType: "draft" };
      // 获得流程的唯一标识uuid
      // this.$router.push({ path: "/flowH5Summary", query: data });
      const routeUrl = this.$router.resolve({ path: "/flowH5Summary", query: data });
      window.open(routeUrl.href, '_blank');
    },
    reset() {
      this.form = {
        keywords: "",
        flowInstanceOwnerId: "",
        approveTime: "",
        flowType: "",
        endDate: "",
        startDate: ""
      };
      this.queryParams.page = 1;
      this.feedbackList = [];
      this.getFeedbackList();
    },
    // 打开时间筛选检测，重置选中
    timeOpen() {
      if (!this.form.startDate) {
        this.$nextTick(() => {
          this.$refs.calendar?.reset();
        });
      }
    },
    timeChange(date) {
      const [start, end] = date;
      this.$refs.timeSearch.toggle(false);
      this.form.startDate = this.formatDate(start);
      this.form.endDate = this.formatDate(end);
      this.getFeedbackList();
    },
    // 清空起始时间
    clearStartTime() {
      this.$refs.calendar.reset();
      this.form.startDate = "";
      this.form.endDate = "";
      this.getFeedbackList();
      this.$refs.timeSearch.toggle(false);
    },
    formatDate(now) {
      // 时间戳转日期格式
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const date = now.getDate();
      return year + "-" + month + "-" + date;
    },
    inputClear() {
      this.queryParams.page = 1;
      this.feedbackList = [];
      this.form.keywords = "";
      this.getFeedbackList();
    },
    inputSearch(row) {
      this.queryParams.page = 1;
      this.feedbackList = [];
      this.form.keywords = row;
      this.getFeedbackList();
    },
    // 筛选
    dressingByScreen() {
      this.queryParams.page = 1;
      this.feedbackList = [];
      this.getFeedbackList();
    },
    // 列表
    async getFeedbackList() {
      this.$toast.loading({ message: "加载中...", forbidClick: true, duration: 5 });
      const {
        queryParams: { page, pageSize }
      } = this;
      const params = {
        ...this.form,
        enterpriseId: this.enterpriseId
      };
      const { data, pageIndex, totalCount } = await flowService.mySubmit(params, page, pageSize);
      this.totalRecords = totalCount;
      if (pageIndex === 1) {
        this.feedbackList = data;
      } else {
        this.feedbackList.push(...data);
      }
      this.$toast.clear();
    },
    // 刷新
    refrash(cb) {
      this.queryParams.page = 1;
      this.form = {
        keywords: "",
        flowInstanceOwnerId: "",
        approveTime: "",
        flowType: "",
        startDate: "",
        endDate: ""
      };
      this.feedbackList = [];
      this.getFeedbackList().then((_) => {
        cb && cb();
      });
    },
    // 加载更多
    loadMore(cb) {
      const { feedbackList, totalRecords } = this;
      if (totalRecords > feedbackList.length) {
        this.queryParams.page++;
        this.getFeedbackList().then((_) => {
          cb && cb(); // 也可以通过ref设置子组件中状态值 this.$refs.approvalList.loading = false
        });
      } else {
        cb && cb();
      }
    },
    // 查询流程类型
    async getDefinitionList() {
      const { data } = await flowService.downList(this.enterpriseId);
      const arr = data?.map((item) => ({ text: item.flowName, value: item.flowDefinitionId }));
      this.definitionList = this.selectData.concat(arr);
    },
    // 查询申请人
    async getUserList() {
      const { data } = await flowService.applicant(this.enterpriseId);
      const arr = data?.map((item) => ({ text: item.flowInstanceOwnerName, value: item.flowInstanceOwnerID }));
      this.userList = this.selectData.concat(arr);
    },
    // 返回
    onClickLeft() {
      appBackMethods();
    },
    onClickRight() {
      console.log("点击右侧按钮");
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .van-dropdown-menu__bar {
  height: 35px;
  line-height: 35px;
}
::v-deep .van-search__content {
  background: #fff;
}
::v-deep .calendar{
  .van-calendar__header-title{
    display: none;
  }
}
#approval-body{
  height: 100%;
  display: flex;
  flex-direction: column;
  .content{
    height: 1px;
    flex-grow: 1;
  }
  .timeBtn {
    width: calc(100% - 32px);
    height: 34px;
    margin: 0 16px 8px;
  }
}
</style>
